// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__EHRzV","content":"styles_content__s_Zgs","footer":"styles_footer__d6hNS"};